import React from 'react'
import { BannerWrapper } from '../style'

interface BannerProps {
  contentBanner?: React.ReactNode
}

const Banner = ({ contentBanner }: BannerProps) => {
  return <BannerWrapper>{contentBanner}</BannerWrapper>
}

export default Banner
